import { sansSerifStyles } from "@pathwright/blocks/src/ui/typography"
import styled from "styled-components"

export const QuestionWrapper = styled.div`
  width: 100%;
  max-width: 800px;
  margin: 0px auto 15px;
  position: relative;
  .styled-field {
    display: none;
  }
  .TextInput {
    margin: 0px 5px;
    padding: 5px 10px !important;
  }
  .TextInput input {
    text-align: center !important;
  }
  .annotation-number,
  .annotation-number > p,
  .SubText,
  .SubText > span {
    color: rgba(0, 0, 0, 0.6);
    font-weight: 500;
    ${sansSerifStyles({ size: 18 })}
  }
  .reset-button {
    border: 0;
    padding: 2px 5px 0px !important;
    line-height: 1;
    ${sansSerifStyles({ size: 18 })}

    .Pathicon {
      margin-top: -3px;
    }
  }

  ${(p) =>
    p.blockStyles
      ? `
    .annotation-number {
      color: ${p.blockStyles.styleAttributes.color};
		}

		.TextInput__input input {
			border-color: ${p.blockStyles.styleAttributes.color};
			color:  ${p.blockStyles.styleAttributes.color};
		}
  `
      : ""}
`

export const AnnotatedImageWrapper = styled.div`
  .AnnotatedImageEdit {
    img {
      filter: opacity(0.5);
    }
  }
`
